<template>
	<div class="table-name" >
		<xl-avatar v-if="row.patient?.bucket" :src="$ossImageByWidthAndHeight({ bucket: row.patient.bucket, dfsID: row.patient.dfsID, w: 40, m: 'fill' })"></xl-avatar>
		<svg class="icon svg-icon svg-icon-avatar" aria-hidden="true" v-else-if="row.patient?.sex === 'female'" @click="toPatient()">
			<use xlink:href="#icon-nv2"></use>
		</svg>
		<svg class="icon svg-icon svg-icon-avatar" aria-hidden="true" v-else @click="toPatient()">
			<use xlink:href="#icon-nan3"></use>
		</svg>
			<span class="name" @click="toPatient()">{{ row.patient?.name }}</span>
	</div>
	<el-popover
		v-if='row.showtip'
    :visible="visible"
    placement="bottom"
		:width="240"
		popper-class="toDetailTip"
		:append-to="appendTo"
  >
    <template #reference>
      <span></span>
    </template>
		<div class="box">
			<span>{{$t('yunshuyouhua.toDetailTip')}}</span>
			<i class="iconfont icon-Group1" @click="gunxitip"></i>
		</div>
  </el-popover>
</template>

<script setup>
import { ref } from 'vue';
import { XlAvatar } from '@shining3d/ui-components';
import { $getLocalStorage, $setLocalStorage } from '@shining3d/common-module/utils/index.js';
import { $ossImageByWidthAndHeight } from '../assets/common/common.js';

import { useRouter, onBeforeRouteLeave } from 'vue-router';
import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang( '@shining3d/app' );
const router = useRouter();
const toPatient = () => {
	// gunxitip();
	// router.push({		
	// 	name: 'patientDetail',
	// 	params: { id: props.row.patientID, whence: 'cases' }
	// });
	// event.stopPropagation();
};
const visible = ref( true );
const gunxitip = () => {
	visible.value = false;
	$setLocalStorage( 'noToPatientTip', true );
};
const props = defineProps({
	row: {
		type: Object,
		default: () => ({})
	},
	appendTo: {
		type: HTMLElement,
		default: null
	}
});
const determine = () => {
	if ( !$getLocalStorage( 'noToPatientTip' )) {
		visible.value = true;
	} else {
		visible.value = false;
	}
};
onBeforeRouteLeave(( to, from, next ) => {
	visible.value = false;
	$setLocalStorage( 'noToPatientTip', true );
	next();
});
determine();
</script>

<style scoped lang="scss">
.table-name {
	
	display: flex;
	align-items: center;
	.xl-avatar {
		flex-grow: 0;
		flex-shrink: 0;
	}
	.name {
		margin-left: 8px;
		text-overflow: ellipsis;
		overflow: hidden;
		&:hover{
			color: $color-b4;
		}
	}
  .svg-icon-avatar {
		width: 40px;
		height: 40px;
		flex-grow: 0;
		flex-shrink: 0;
		&:hover+.name{
			color: $color-b4;
		}
	}
}

</style>
<style lang="scss">
	.toDetailTip{
		width: 240px;
		// height: 36px;
		background-color: rgba(85, 135, 255, 1) !important;
		color: white !important;
		border-radius: 4px !important;
		padding: 0 !important;
		top: -9px !important;
		left: 62px !important;
		.el-popper__arrow::before{
			background-color: rgba(85, 135, 255, 1) !important;
		}
		.box{
			margin-top: 8px;
			margin-left: 16px;
			margin-bottom: 8px;
			display: flex;
			max-width: 213px;
			.iconfont{
				margin-left: 16px;
				line-height: 20px;
				&:hover{
					cursor: pointer;
				}
			}
		}
	}
</style>
